; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Models/ContentSearch/FacetPanel',["jquery", "score_bootstrap/Models/Search/FacetPanel"], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery")) :
            console && console.error('SearchResults does not support non-amd script loading.');
}(this/* window */, function ($, ScoreFacetPanel) {

    function FacetPanel(panelElement) {

        var facetPanel = $(panelElement).data('facet');
        if (facetPanel != null) {
            // prevent assigning facet panel twice to the same element.
            // IPA use it since it has a custom logic on top of FacetContainer
            return facetPanel;
        }

        // call parent class
        ScoreFacetPanel.apply(this, [].slice.call(arguments));

        $(panelElement).data('facet', this);
    }

    FacetPanel.prototype = Object.create(ScoreFacetPanel.prototype);

    return FacetPanel;
}));
